import React, { useRef, useEffect, useState } from 'react';
import Cropper from 'react-cropper';
import "cropperjs/dist/cropper.css";

const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    content: {
        background: '#fff',
        padding: '20px',
        borderRadius: '0px',
        width: '90%',
        maxWidth: '800px',
    },
};

// Define your min and max dimensions here
const MIN_WIDTH = 200;
const MIN_HEIGHT = 200;
const MAX_WIDTH = 800;
const MAX_HEIGHT = 800;

const ImageCropper = ({ uploadedImage, onCropped, onClose }) => {
    const cropperRef = useRef(null);
    const [image, setImage] = useState(null);
    const [cropSize, setCropSize] = useState({ width: 0, height: 0 });
    const [validationError, setValidationError] = useState('');

    useEffect(() => {
        if (uploadedImage) {
            setImage(URL.createObjectURL(uploadedImage));
        }
    }, [uploadedImage]);

    // Called on crop and cropend events to update current crop size
    const onCrop = () => {
        const cropper = cropperRef.current?.cropper;
        if (!cropper) return;

        const cropData = cropper.getCropBoxData();
        const width = Math.round(cropData.width);
        const height = Math.round(cropData.height);
        setCropSize({ width, height });

        // Validate size and set error message if any
        if (width < MIN_WIDTH || height < MIN_HEIGHT) {
            setValidationError(`Current size is smaller than minimum allowed (${MIN_WIDTH}x${MIN_HEIGHT})`);
        } else if (width > MAX_WIDTH || height > MAX_HEIGHT) {
            setValidationError(`Current size exceeds maximum allowed (${MAX_WIDTH}x${MAX_HEIGHT})`);
        } else {
            setValidationError('');
        }
    };

    const outputType = uploadedImage?.type || 'image/jpeg';

    const cropImage = () => {
        const cropper = cropperRef.current?.cropper;
        if (!cropper) return;

        if (validationError) return; // prevent cropping if invalid size

        const canvas = cropper.getCroppedCanvas({
            minWidth: MIN_WIDTH,
            maxWidth: MAX_WIDTH,
            minHeight: MIN_HEIGHT,
            maxHeight: MAX_HEIGHT,
        });

        // if (canvas) {
        //     canvas.toBlob((blob) => {
        //         if (blob) {
        //             onCropped(blob);
        //             onClose(); // close popup after cropping
        //         }
        //     }, 'image/jpeg');
        // }
        if (canvas) {
            canvas.toBlob((blob) => {
                if (blob) {
                    // Get original file name and extension
                    const originalName = uploadedImage?.name || 'cropped-image.jpg';
                    const extensionMatch = originalName.match(/\.[0-9a-z]+$/i);
                    const extension = extensionMatch ? extensionMatch[0] : '.jpg';

                    // Replace extension with the blob's mime type extension if needed
                    const mimeType = blob.type; // e.g. 'image/jpeg', 'image/png'
                    let extFromMime = '';
                    if (mimeType === 'image/jpeg') extFromMime = '.jpg';
                    else if (mimeType === 'image/png') extFromMime = '.png';
                    else extFromMime = extension; // fallback to original

                    // Replace old extension with new extension
                    const baseName = originalName.replace(/\.[0-9a-z]+$/i, '');
                    const fileName = baseName + extFromMime;

                    // Create new File object with same filename & extension
                    const file = new File([blob], fileName, {
                        type: mimeType,
                        lastModified: Date.now(),
                    });

                    onCropped(file);
                    onClose(); // close popup after cropping
                }
            }, outputType);  // You can adjust output format here if you want
        }
    };

    if (!image) return null;

    // Determine color for current crop size
    const currentSizeColor =
        cropSize.width < MIN_WIDTH || cropSize.height < MIN_HEIGHT
            ? 'reporttext1211red'
            : cropSize.width > MAX_WIDTH || cropSize.height > MAX_HEIGHT
                ? 'reporttext12un'
                : 'reporttext1211';

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.content}>
                <h5>Crop Image</h5>
                <Cropper
                    src={image}
                    ref={cropperRef}
                    style={{ height: 400, width: '100%' }}
                    viewMode={1}
                    guides={false}
                    background={false}
                    responsive={true}
                    dragMode="move"
                    crop={onCrop}
                    cropend={onCrop}
                />
                <div className='row mt-3'>
                    <div className='col-12 '>
                        <span className='formlabel-input'>Current Size</span><span className='px-2'>:</span>
                        <span className={currentSizeColor}>
                            {cropSize.width}px x {cropSize.height}px
                        </span>
                    </div>
                    <div className='col-12 mt-2'>
                        <span className='formlabel-input'>Max Size</span><span className='px-2'>:</span> <span className='formlabel-input'>{MAX_WIDTH}px x {MAX_HEIGHT}px</span>
                    </div>
                    <div className='col-12 mt-2'>
                        <span className='formlabel-input'>Min Size</span><span className='px-2'>:</span> <span className='formlabel-input'>{MIN_WIDTH}px x {MIN_HEIGHT}px</span>
                    </div>
                </div>
                {validationError && (
                    <div className='col-12 mt-2'>
                        <span className={currentSizeColor}>{validationError}</span>
                    </div>
                )}
                <div className="d-flex justify-content-end mt-3">
                    <button className="btn-cancel btn-filter-action border-none" onClick={onClose}>Cancel</button>
                    <button
                        className="btn-fun ps-4 pe-4 fs-7"
                        onClick={cropImage}
                        disabled={!!validationError}
                    >
                        Upload
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
